import { render, staticRenderFns } from "./PositiveIcon.vue?vue&type=template&id=600ddf0d&functional=true"
import script from "./PositiveIcon.vue?vue&type=script&lang=js"
export * from "./PositiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports